import React from "react";
import ReactDOM from "react-dom";

import ModalScamWarning from "shared/components/ModalScamWarning";

/**
 * The controller that mounts and opens the modal.
 * Binds to the window so that legacy messenger can call it.
 *
 * @name ScamWarning
 * @global
 */
const ScamWarning = {
	/**
	 * Creates the modal mount node and appends it to the page.
	 *
	 * @method
	 * @param {Boolean} shouldOpen - Whether or not to open immediately.
	 */
	init(shouldOpen = false) {
		if (!this.$el) {
			this.$el = document.createElement("div");
			this.$el.id = "scam_warning_modal";
			document.body.appendChild(this.$el);
		}

		if (shouldOpen) {
			this.open();
		}
	},

	/**
	 * Closes the modal. In this case that means unmounting the React component.
	 * It really shouldn't be this way, but we kind of have to because this is a
	 * standalone component, it's not part of a larger app that can maintain an
	 * open/close state.
	 *
	 * @method
	 */
	close() {
		// run this in another thread (otherwise React will complain,
		// because we're running this in an event handler, and the element is removed
		// AFTER the event is handled. yeah i don't really understand either)
		requestAnimationFrame(() => {
			ReactDOM.unmountComponentAtNode(this.$el);
		});
	},

	/**
	 * Opens the React component. If the mount node isn't there, this method will
	 * call init to add it to the page and then run the open method again. It
	 * should just work every time you call it.
	 */
	open() {
		if (!this.$el) {
			this.init(true);
			return;
		}

		ReactDOM.render(<ModalScamWarning />, this.$el);
	},
};

// Back to the old school, attach this shit to the window. This kind of has
// to be this way, since this is included in the common bundle.
window.ScamWarning = ScamWarning;

/**
 * And the new school way, for future-friendliness.
 *
 * Exports the scam warning singleton. Call `open` to add it to the DOM.
 *
 * @exports {Object} ScamWarning
 */
export default ScamWarning;



// WEBPACK FOOTER //
// ./src/shared/util/ScamWarning.js